module.exports = __webpack_public_path__ + "static/62-c5bb23fe2b1344d5b98f258e53145494.png";